/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CourseCertificate } from '../../models/course-certificate';

export interface ApiRequestCoursePreviewCertificateGet$Params {
  id?: string;
  type?: number;
}

export function apiRequestCoursePreviewCertificateGet(http: HttpClient, rootUrl: string, params?: ApiRequestCoursePreviewCertificateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CourseCertificate>> {
  const rb = new RequestBuilder(rootUrl, apiRequestCoursePreviewCertificateGet.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CourseCertificate>;
    })
  );
}

apiRequestCoursePreviewCertificateGet.PATH = '/api/Request/Course/PreviewCertificate';
